/**
 * Footer — minimal, premium.
 */
import React from "react";
import { Link } from "react-router-dom";
import { Github } from "lucide-react";
import outlappedWordmark from "../assets/outlapped-wordmark.svg";

export default function Footer() {
    return (
        <footer
            className="relative border-t border-white/5 mt-24"
            data-testid="footer"
        >
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 grid grid-cols-1 md:grid-cols-4 gap-8">
                <div className="md:col-span-2">
                    <img src={outlappedWordmark} alt="Outlapped" className="h-10 w-auto" />
                    <p className="mt-4 text-sm text-zinc-500 max-w-md">
                        F1 race intelligence — countdowns, historical replay, race strategy,
                        and Formula 1 events explained in plain English.
                    </p>
                    <p className="mt-3 font-mono text-[10px] tracking-widest text-zinc-600">
                        INDEPENDENT RACE INTELLIGENCE · NOT AFFILIATED WITH FORMULA 1
                    </p>
                </div>
                <div>
                    <div className="label-eyebrow mb-3">Explore</div>
                    <ul className="space-y-2 text-sm text-zinc-400">
                        <li><Link to="/replay" className="hover:text-white">Race Replay</Link></li>
                        <li><Link to="/calendar" className="hover:text-white">Calendar</Link></li>
                        <li><Link to="/drivers" className="hover:text-white">Drivers</Link></li>
                        <li><Link to="/teams" className="hover:text-white">Teams</Link></li>
                    </ul>
                </div>
                <div>
                    <div className="label-eyebrow mb-3">Learn</div>
                    <ul className="space-y-2 text-sm text-zinc-400">
                        <li><Link to="/learn" className="hover:text-white">Learn F1</Link></li>
                        <li><Link to="/standings" className="hover:text-white">Standings & Records</Link></li>
                        <li><Link to="/news" className="hover:text-white">Race IQ Briefing</Link></li>
                    </ul>
                </div>
            </div>
            <div className="border-t border-white/5">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-5 flex items-center justify-between">
                    <p className="text-xs text-zinc-600">
                        © {new Date().getFullYear()} Outlapped · Built for race fans
                    </p>
                    <div className="flex items-center gap-3 text-zinc-500">
                        <Github className="h-4 w-4" />
                    </div>
                </div>
            </div>
        </footer>
    );
}
